import { Button, Table, Tabs } from "antd";
import styled, { css, keyframes } from "styled-components";
import { enterTop } from "../Sales/Checkout/styles";

export const TopContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

/**
 * INFORMACP-4818: os atalhos do cabeçalho ficam empilhados e alinhados à direita, conforme o
 * mock — "Lista de Colaboradores" e, logo abaixo, "Bonificação".
 */
export const HeaderLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;

export const HeaderLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  h2 {
    margin-bottom: 0;
  }
`;

export const CustomButton = styled(Button)`
  background-color: rgba(6, 142, 195, 1);
  font-family: "Inter";
  color: rgba(255, 255, 255, 1);
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    transform: scale(1.05);
    background-color: rgba(6, 142, 195, 1);
    color: rgba(255, 255, 255, 1);
  }

  &:focus {
    background-color: rgba(6, 142, 195, 1);
    color: rgba(255, 255, 255, 1);
  }
`;
const tabGlowTwice = keyframes`
  0%, 50%, 100% {
    background-color: rgba(6, 142, 195, 0);
    box-shadow: 0 0 0 0 rgba(6, 142, 195, 0);
  }
  25%, 75% {
    background-color: rgba(6, 142, 195, 0.1);
    box-shadow: 0 0 0 4px rgba(6, 142, 195, 0.18);
  }
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    margin-right: -15px;
    color: rgba(98, 116, 142, 1);
    font-family: "Inter";
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
  }
  .ant-tabs-tab.ant-tabs-tab-active {
    color: rgba(6, 142, 195, 1);
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
  }

  @media (max-width: 1200px) {
    .ant-tabs-tab {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-tabs-tab {
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    .ant-tabs-tab {
      font-size: 10px;
    }
  }

  ${({ $glow }) =>
    $glow &&
    css`
      .ant-tabs-tab.ant-tabs-tab-active {
        animation: ${tabGlowTwice} 1.2s ease;
        border-radius: 6px;
      }
    `}
`;

export const CredentialsTable = styled(Table)`
  margin-top: 08px;
  animation: ${enterTop} 1s;
  .ant-table-thead > tr > th {
    background-color: white !important;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    color: rgba(49, 65, 88, 1);
  }
  thead .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: inherit;
    border-color: inherit;
  }

  .ant-table {
    overflow: hidden;
    border: 1px solid rgba(226, 232, 240, 1);
    border-radius: 10px;
  }
  .ant-table-tbody > tr.ant-table-row-selected > td {
    border-color: transparent !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #11a7d9;
    border-color: #11a7d9;
    border-radius: 4px;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #11a7d9;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: #11a7d9;
  }

  .ant-table-tbody > tr:nth-child(odd) > td,
  .ant-table-tbody > tr:nth-child(odd) > td.ant-table-column-sort {
    background-color: rgba(239, 239, 240, 0.25);
  }

  .ant-table-tbody > tr:nth-child(even) > td,
  .ant-table-tbody > tr:nth-child(even) > td.ant-table-column-sort {
    background-color: white;
  }

  .ant-table-tbody > tr:hover > td,
  .ant-table-tbody > tr:hover > td.ant-table-column-sort,
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-column-sort {
    background-color: #fafafa;
  }

  .ant-table-tbody > tr.highlighted-printed-row,
  .ant-table-tbody > tr.highlighted-printed-row > td,
  .ant-table-tbody > tr.highlighted-withdrawn-row,
  .ant-table-tbody > tr.highlighted-withdrawn-row > td {
    background-color: rgba(6, 142, 195, 0.12) !important;
    transition: background-color 0.3s ease;
  }

  @media (max-width: 1200px) {
    .ant-table-thead > tr > th {
      font-size: 14px;
    }

    .ant-table-tbody > tr > td {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th {
      font-size: 12px;
    }

    .ant-table-tbody > tr > td {
      font-size: 12px;
    }
  }
`;

export const AssociatedCredentialsTopItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 37px;
`;

const bannerEnter = keyframes`
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SearchBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 8px 0 16px;
  padding: 16px;
  background-color: #eaf4fb;
  border: 1px solid #cbe3f5;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  animation: ${bannerEnter} 0.6s cubic-bezier(0.16, 1, 0.3, 1);
`;

export const SearchBannerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #068ec3;
  font-size: 20px;
  margin-top: 2px;
`;

export const SearchBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SearchBannerTitle = styled.span`
  color: #314158;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`;

export const SearchBannerText = styled.span`
  color: #62748e;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;

  strong {
    color: #314158;
    font-weight: 600;
  }
`;

export const SearchBannerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const SearchBannerButton = styled(Button)`
  height: 32px;
  border-radius: 8px;
  padding: 4px 12px;
  background: #068ec3;
  border: none;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;

  &:hover,
  &:focus {
    background: #05769e;
    color: #ffffff;
  }
`;

export const SearchBannerGhostButton = styled(Button)`
  height: 32px;
  border-radius: 8px;
  padding: 4px 12px;
  background: #ffffff;
  border: 1px solid #068ec3;
  color: #068ec3;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;

  &:hover,
  &:focus {
    background: #f5fbfe;
    border-color: #068ec3;
    color: #068ec3;
  }
`;

const skeletonShimmer = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

export const SkeletonCard = styled.div`
  width: 100%;
  height: 139px;
  margin-bottom: 15px;
  padding: 24px 16px;
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 1);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const SkeletonShimmer = styled.div`
  flex-shrink: 0;
  width: ${({ $w }) => $w || "100%"};
  height: ${({ $h }) => $h || "16px"};
  border-radius: ${({ $radius }) => $radius || "6px"};
  background: linear-gradient(90deg, #eef2f6 25%, #e2e8f0 37%, #eef2f6 63%);
  background-size: 400px 100%;
  animation: ${skeletonShimmer} 1.4s ease infinite;
`;

// Botao "limpar" exibido dentro do campo de busca (icone X a direita).
export const ClearSearchButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #e2e8f0;
  color: #475569;
  font-size: 13px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: #cbd5e1;
    color: #1e293b;
  }

  &:focus {
    outline: 2px solid #068ec3;
    outline-offset: 1px;
  }
`;
